import React, { Component } from "react";
import { PartnerCreateModal, ToolTip } from "../../..";
import { changeCardCode, openPartner, openPersonContact, refreshPartner, selectContact, selectPartner, validateEnter } from "../../utils/businessPartner";
import { refreshTotal } from "../../utils/totals";
import { restartTabs } from "../../utils/modal";
import moment from "moment";
import PersonContactModal from "../../../PersonContactModal";
import { invFields } from "../../../../libs/utils/Const";
import ApiClient from "../../../../libs/apiClient";
import { changeScopCode } from "../../utils/scopCode";
import { openSeries, selectSeries } from "../../utils/seriesService";
import SeriesCreateModal from "../../../SeriesCreateModal";
let apiClient = ApiClient.getInstance();

export default class InventoryHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      partners: [],
      editMode: false,
      U_FMB_DEF_PLReqStockTransfer: null,
      U_FMB_DEF_PLStockTransfer: null,
      flagAgentCode: false,
      contacts: [],
      series: [],
    }
  }


  change_U_BPP_MDTS = async (event) => {
    const { newOrderModel, refreshModel } = this.props;
    newOrderModel.U_BPP_MDTS = event.nativeEvent.target.value;

    refreshModel(newOrderModel);
  };
  change_U_STR_FE_GRE_CodigoMotivoTraslado = async (event) => {
    const { newOrderModel, enableSpinner, showAlert, refreshModel } = this.props;
    newOrderModel.U_STR_FE_GRE_CodigoMotivoTraslado = event.nativeEvent.target.value;
    const Field = 'U_STR_FE_GRE_CodigoMotivoTraslado';
    const value = event.nativeEvent.target.value;
    const linkedFields = invFields?.filter(field => field?.active && field?.linkedValue === Field) ?? [];  // Campos dependientes
    if (linkedFields?.length) {
      if (value) {
        enableSpinner(true);
        let data = {
          Field,
          param1: value
        };
        let res = await apiClient.getFormattedQueriesByCUFD(data);
        enableSpinner(false);

        if (res?.status) {
          const row = res?.data ?? {};

          for (const lf of linkedFields) { // Asignar valores a campos dependientes
            const targetField = lf.Field;

            if (row.hasOwnProperty(targetField)) {
              newOrderModel[targetField] = row[targetField];
            } else {
              newOrderModel[targetField] = '';
            }
          }

        } else { // Limpiar dependientes
          showAlert({ type: 'error', message: `Ocurrió un error al consultar los valores dependientes del campo` });
          for (const lf of linkedFields) {
            newOrderModel[lf.Field] = '';
          }
        }

      } else { // Limpiar dependientes
        for (const lf of linkedFields) {
          newOrderModel[lf.Field] = '';
        }
      }
    }

    refreshModel(newOrderModel);
  };

  selectDocDate = async (event) => {
    const { newOrderModel, showAlert, view, enableSpinner,refreshModel } = this.props;
    let today = moment(new Date()).format('YYYY-MM-DD');
    if (event.nativeEvent.target.value > today) {
      showAlert({
        type: 'error',
        message: 'La fecha de contabilización tiene que ser igual o menor al día actual',
      });
      return;
    }
    newOrderModel.DocDate = event.nativeEvent.target.value;
    newOrderModel.TaxDate = event.nativeEvent.target.value;

    if (newOrderModel.Items.length > 0 && (view === 'invoice' || view === 'orderSales' || view === 'debitNote' || view === "invoiceReserve")) {
      let CardCode = newOrderModel.CardCode;
      let DocDate = newOrderModel.DocDate;
      enableSpinner(true);
      let getItemResponse = await apiClient.getItemsPrice(CardCode, newOrderModel.Items, DocDate);
      enableSpinner(false);
      if (getItemResponse.status === 1) {
        newOrderModel.Items = getItemResponse.data;
      }
      refreshTotal(this,newOrderModel);
    } else {
      refreshModel(newOrderModel);
    }



  };




  render() {
    const {
      newOrderModel,
      action,
      view,
      prices,
      requestPartialEdit
    } = this.props;
    const {
      partners,
      partnerType,
      pageTotal,
      indexPurchaseRequest,
      contacts,
      editMode,
      series,
    } = this.state;
    // Al crear nuevo documento trae cero y no existe en el mapeo (Default -1 Ult precio de compra en SAP)
    newOrderModel.GroupNum = newOrderModel.GroupNum === 0 ? -1 : newOrderModel.GroupNum;

    const scopCodeIn = ["transfers", "transfersRequest"];
    return (
      <div className="row" style={{ paddingRight: 0 }}>
        <PartnerCreateModal
          data={partners}
          type={partnerType}
          totalPage={pageTotal}
          newOrderModel={newOrderModel}
          selectPartner={(a, b) => selectPartner(this, a, b)}
          cleanData={() => this.setState({ partners: [] })}
          refreshPartner={(a, b) => refreshPartner(this, a, b)}
          indexPurchaseRequest={indexPurchaseRequest}
          view={view}
        />
        <PersonContactModal
          data={contacts}
          selectContact={() => selectContact(this)}
          cleanData={() => this.setState({ contacts: [] })}
        />
        <SeriesCreateModal
          data={series}
          selectSerie={(...args) => selectSeries(this, ...args)}
          cleanData={() => this.setState({ series: [] })}
        />
        {/*Priemra columna*/}
        <div className="col-sm">
          {/*No del cliente*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1">Cliente</span>
            </div>
            <input
              type="text"
              className="form-control input-sm"
              id="txtPartner"
              style={{ backgroundColor: newOrderModel.partnerSelected ? 'rgb(248,242,209)' : 'transparent' }}
              disabled={action === 2}
              onKeyPress={(ev) => {
                if (ev.key === 'Enter') {
                  openPartner(this);
                }
              }}
              onChange={(e) => changeCardCode(this, e)}
              value={newOrderModel.CardCode ? newOrderModel.CardCode : ''}
            />
            {action == 1 && (
              <button
                type="button"
                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                className="input-group-text"
                onClick={() => openPartner(this)}>
                <i className="fas fa-user" />
              </button>
            )}
          </div>
          {/*Nombre del cliente*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
            </div>
            <input
              type="text"
              className="form-control input-sm"
              id="txtName"
              disabled="true"
              value={newOrderModel.CardName ? newOrderModel.CardName : ''}
            />
          </div>
          {/*Persona de Contacto*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1">Contacto</span>
            </div>
            <input
              type=" text"
              className="form-control"
              id="txtContactPerson"
              disabled="true"
              value={newOrderModel.CntctName ? newOrderModel.CntctName : ''}
            />
            {(action == 1 || (action == 2)) && (
              <button
                type="button"
                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                className="input-group-text"
                onClick={() => openPersonContact(this)}>
                <i className="fa fa-list" aria-hidden="true" />
              </button>
            )}
          </div>
          {/*Address:*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1">Dirección</span>
            </div>
            <input
              type=" text"
              className=" form-control btn-outline-secondary"
              id="txtCustomerRefNo"
              disabled="true"
              value={newOrderModel.Address ? newOrderModel.Address : ''}
              onChange={this.changeAddress}
              style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
            />
          </div>

          {((newOrderModel.OriginDocumentCreate === 'transfers') && (action === 1)) &&
            <>
              {/* Almacén de transito */}
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de Traslado</span>
                </div>
                <select className="form-control"
                  onChange={event => this.changeAlmacenTransito(event)}
                  disabled={newOrderModel.OriginDocumentCreate === 'transfersRequest' ? true : false}
                  value={newOrderModel?.Transit ?? ""} >
                  <option value="1">Sucursal a Sucursal</option>
                  <option value="2">Recepción de CEDIS</option>
                  <option value=""> Traspaso directo</option>
                  {/* <option value="3">Sucursal a CEDIS</option> */}
                </select>
              </div>

              {newOrderModel.OriginDocumentCreate === 'transfers' &&
                <>
                  {/*NUMERO DE DOCUMENTO PARA REVERSA:*/}
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text font-weight-bold" id="basic-addon1">No. Doc Recuperar</span>
                    </div>
                    <input type=" text" placeholder="Documentos pendientes CEDIS" className="form-control "
                      disabled={true}
                      onKeyDown={(eve) => {
                        if (eve.key === 'Enter') { this.OpenTransfers() }
                      }}
                      value={newOrderModel?.DocNumCEDIS ?? ''}
                      onChange={event => this.ChangeDocNumCEDIS(event.target.value)}
                    />

                    <button type="button"
                      className="input-group-text"
                      style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                      disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? true : false}
                      onClick={() => this.OpenTransfers()}>
                      <i className="fa fa-list" aria-hidden="true" />
                    </button>

                  </div>

                  {/*>almacen de entrada CEDIS*/}
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text font-weight-bold" id="basic-addon1">Almacén de entrada</span>
                    </div>
                    <input
                      type=" text"
                      placeholder="Almacén Recepcion CEDIS"
                      className="form-control "
                      // style={{ backgroundColor: 'transparent', color: '#000', paddingTop: 1, paddingBottom: 2, maxWidth: 800 }}
                      disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? true : false}
                      onKeyPress={(eve) => {
                        if (eve.key === 'Enter') {
                          this.openAlmacen(null, 117);
                        }
                      }}
                      value={newOrderModel.WarehouseCEDIS ?? ''}
                      onChange={event => this.ChangeAlmacenRecepCEDIS(event)}
                    />

                    <button type="button"
                      style={{ backgroundColor: 'transparent', color: '#EABF28', paddingTop: 2, paddingBottom: 2 }}
                      className="input-group-text"
                      disabled={((action === 2) || (action === 1 && Number(newOrderModel?.Transit) !== 2)) ? true : false}
                      onClick={() => this.openAlmacen(null, 117)}>
                      <i className="fa fa-list" aria-hidden="true" />
                    </button>
                  </div>
                </>
              }
            </>
          }
          {(view === 'invoiceBorrador' && newOrderModel.ObjType === "67" && newOrderModel.U_FMB_EditTraslado === 'N' && newOrderModel.SendRequestEdition !== 'Y') && <div className="input-group mb-3">
            <div className="input-group-prepend">
            </div>
            <button
              type="button"
              className="btn botonCorrect text-black input-group-text"
              style={{ width: '100%' }}
              onClick={() => requestPartialEdit()}>
              <i className="fa fa-pen-to-square" aria-hidden="true" />
              &nbsp;
              Solicitar edición parcial
            </button>
          </div>}
          {scopCodeIn.includes(view) &&
            (
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de salida del documento</span>
                </div>
                <select className="form-control"
                  onChange={event => this.change_U_BPP_MDTS(event)}
                  disabled={(action === 2 && !editMode) ? true : false}
                  value={newOrderModel?.U_BPP_MDTS ?? ""} >

                  <option value="">-Selecciona-</option>
                  <option value="TSE">Externa</option>
                  <option value="TSI">Interna</option>
                </select>
              </div>
            )
          }
          {scopCodeIn.includes(view) &&
            (
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text font-weight-bold" id="basic-addon1">Codigo Motivo Traslado</span>
                </div>
                <select className="form-control"
                  onChange={event => this.change_U_STR_FE_GRE_CodigoMotivoTraslado(event)}
                  disabled={(action === 2 && !editMode) ? true : false}
                  value={newOrderModel?.U_STR_FE_GRE_CodigoMotivoTraslado ?? ""} >

                  <option value="">-Selecciona-</option>
                  <option value="01">Venta</option>
                  <option value="02">Compra</option>
                  <option value="03">Venta con entrega a terceros</option>
                  <option value="04">Translado entre establecimientos de la misma empresa</option>
                  <option value="05">Consignación</option>
                  <option value="06">Devolución</option>
                  <option value="07">Recojo de bienes transformados</option>
                  <option value="08">Traslado Importacion</option>
                  <option value="09">Traslado Exportacion</option>
                  <option value="13">Otros</option>
                  <option value="14">Venta sujeta a confirmación del comprador</option>
                  <option value="17">Traslado de bienes para transformación</option>
                  <option value="18">Traslado emisor itenerante CP</option>
                  <option value="19">Traslado a zona primaria</option>
                </select>
              </div>
            )
          }

          {/* SCOP */}
          {scopCodeIn.includes(view) && (
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text font-weight-bold">Código SCOP</span>
              </div>
              <input
                type="text"
                maxLength="11"
                className="form-control"
                id="txtScop"
                disabled={action === 2 && !editMode}
                value={newOrderModel?.U_FMB_SCOP_CODE ?? ""}
                onChange={(e) => changeScopCode(this, e)}
                onKeyPress={(eve) => {
                  if (eve.key === 'Enter') {
                    this.props.scoopTools.checkScoop()
                  }
                }}
              />
              {(action === 1 || (action === 2 && editMode)) && (
                <button
                  type="button"
                  style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                  className="input-group-text"
                  onClick={this.props.scoopTools.checkScoop}>
                  <i className="fa fa-cloud" aria-hidden="true" />
                </button>
              )}
            </div>
          )}
        </div>

        {/*Segunda columna*/}
        <div className="col-sm">
          {/*No Serie*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
            </div>
            <input
              type=" text"
              className=" form-control"
              id="txtDocumentDate"
              disabled="true"
              value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
            />
            {action == 1 && (
              <button
                type="button"
                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                className="input-group-text"
                onClick={() => openSeries(this)}>
                <i className="fa fa-list" aria-hidden="true" />
              </button>
            )}
          </div>
          {/*N°:*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
            </div>
            <input
              type=" text"
              className=" form-control"
              id="txtNo"
              disabled="true"
              value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ''}
            />
          </div>
          {/*Fecha de contabilización:*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1">F. Contabilización</span>
            </div>
            <input
              id="txtPostingDate"
              style={{
                width: '100%',
                important: true,
                backgroundColor: 'transparent',
                borderColor: '#ced4da',
                color: '#000',
              }}
              className="form-control  btn-outline-secondary"
              type={action == 2 ? 'date' : 'date'}
              disabled={action == 2 ? true : false}
              placeholder="Fecha min"
              autoComplete="off"
              value={newOrderModel.DocDate ? newOrderModel.DocDate : ''}
              onChange={this.selectDocDate}
            />
          </div>
          {/*>Fecha de documento:*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1">F. Documento</span>
            </div>
            <input
              type="date"
              style={{
                width: '100%',
                important: true,
                backgroundColor: 'transparent',
                borderColor: '#ced4da',
                color: '#000',
              }}

              disabled={action == 2}
              className=" form-control"
              id="txtStatus"
              max='9999-12-31'
              autoComplete="off"
              value={newOrderModel.TaxDate ? newOrderModel.TaxDate : ''}
              onChange={this.selectDocDueDate}
            />
          </div>
          {/*>almacen origen:*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1">De Almacén</span>
            </div>
            <input
              type="text"
              placeholder="Almacén origen"
              className="form-control"
              disabled
              onKeyPress={({ key }) => { if (key === 'Enter') { this.openAlmacen(null, 2); } }}
              value={newOrderModel.Filler ? newOrderModel.Filler : ''}
            // onChange={event => this.changeAlmacenOrigen(event)} // Isra pidio que el almacen de origen no se pueda cambiar
            />
            {(action === 1 && ((!newOrderModel.Filler || newOrderModel.Filler === "") || (!newOrderModel.Transit || newOrderModel.Transit === "")) && (Number(newOrderModel?.Transit || 0) !== 2)) && (<button type="button" // Solo mostrar si no se detecto el almacen de origen
              style={{
                backgroundColor: 'transparent',
                color: '#EABF28',
                paddingTop: 2,
                paddingBottom: 2,
              }}
              className="input-group-text"
              onClick={() => this.openAlmacen(null, 2)}>
              <i className="fa fa-list" aria-hidden="true" />
            </button>
            )}
          </div>
          {/*>almacen Finall opcional:*/}
          {/* {action == 1 && <div className="form-group row" id="div1">
                                  <label htmlFor="txtDocumentDate" className="col-md-4 col-sm-12 col-form-label font-weight-bold">
                                      Almacén Tránsito:
                                  </label>
                                  <div className="col-md-6 col-sm-12">
                                      <input
                                          type=" text"
                                          className=" form-control"
                                          id="txtStatus"
                                          disabled="true"
                                          value={newOrderModel.wareHouseFinalOptionalValue ? newOrderModel.wareHouseFinalOptionalValue : ''}
                                      />
                                  </div>
                                  {action == 1 && (
                                      <button
                                          type="button"
                                          style={{
                                              backgroundColor: 'transparent',
                                              color: '#EABF28',
                                          }}
                                          className="btn "
                                          onClick={() => this.openAlmacen(null, 4)}>
                                          <i className="fa fa-list" aria-hidden="true"/>
                                      </button>
                                  )}
                              </div>} */}
          {/*>almacen destino:*/}
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text font-weight-bold" id="basic-addon1"> Almacén Destino <ToolTip tips={[{ message: "Seleccione el almacén con el botón" }]} position="up" width="200" /> </span>
            </div>
            <input
              type="text"
              placeholder="Almacén destino"
              className="form-control"
              disabled
              readOnly
              // disabled={(action === 2 && !editMode) || (Number(newOrderModel?.Transit || 0) === 2)}
              // onKeyPress={(eve) => {
              //     if (eve.key === 'Enter') {
              //         this.openAlmacen(null, 3);
              //     }
              // }}
              value={newOrderModel.ToWhsCode ? newOrderModel.ToWhsCode : ''}
            // onChange={event => this.changeAlmacenDestino(event)}
            />
            {(action === 1 && (Number(newOrderModel?.Transit || 0) !== 2)) && (<button type="button"
              style={{
                backgroundColor: 'transparent',
                color: '#EABF28',
                paddingTop: 2,
                paddingBottom: 2,
              }}
              className="input-group-text"
              onClick={() => this.openAlmacen(null, 3)}>
              <i className="fa fa-list" aria-hidden="true" />
            </button>
            )}
          </div>

          {/* Lista de Precios: */}
          {((view === 'transfers' || view === 'transfersRequest')) && (
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text font-weight-bold" id="basic-addon1">Lista De Precios</span>
              </div>
              <select className="form-control" disabled={(action === 2 && !editMode) ? true : false}
                onChange={action === 1 ? (event) => this.changeSelectedFieldDocument(event) : ''}
                value={newOrderModel.GroupNum || -1} >

                {prices?.map(price => {
                  return (
                    <option value={price.ListNum}>{price.ListName}</option>
                  )
                })}
                <option value={-1}>Último precio de compra</option>
                <option value={-2}>Último precio determinado</option>
              </select>
            </div>)}
        </div>
      </div>
    );
  }
}